import React, { useEffect, useRef, useState } from "react";
import user from "../../assets/1.jpg";
import qrScan from "../../assets/svg/qrScan.svg";
import clock from "../../assets/svg/clock.svg";
import patrol from "../../assets/svg/speaker.svg";
import checkout from "../../assets/svg/checkout.svg";
import checkin from "../../assets/svg/checkin.svg";
import signIn from "../../assets/svg/signIn.svg";
import signOut from "../../assets/svg/signOut.svg";
import SecondaryHeader from "../SecondaryHeader/SecondaryHeader";
import MenuBar from "../MenuBar/MenuBar";
import { HttpGet } from "../../providers/HttpClient";
import moment from "moment";
import "./historyPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import L from "leaflet";
import { Sheet } from "react-modal-sheet";

const defaultIcon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = defaultIcon;

const History: React.FC = () => {
  moment.locale("es");
  const [historyData, setHistory] = useState<any>([]);
  const [page, setPage] = useState<any>(0);
  const [size, setSize] = useState<any>(10);
  const [userCategory, setuUserCategory] = useState(
    JSON.parse(localStorage.getItem("tokenInfo")).category
  );
  const [attendanceType, setAttendanceType] = useState<any>(
    JSON.parse(localStorage.getItem("companyProfile")).attendanceType
  );
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [detailData, setDetailData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  const openPopup = () => {
    setIsVisible(true);
  };

  const closePopup = () => {
    setIsVisible(false);
  };

  const GetHistory = async () => {
    setLoading(true);
    HttpGet(
      `member/attendance?size=${size}&page=${page}&sort=createTime&dir=-1`
    )
      .then((res: any) => {
        setHistory(res.data.content);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const GetHistorySelfie = async () => {
    setLoading(true);
    HttpGet(
      `member/attendance_by_photo?size=${size}&page=${page}&sort=createTime&dir=-1`
    )
      .then((res: any) => {
        setHistory(res.data.content);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const LeafletMap = ({
    lat,
    lon,
    label,
  }: {
    lat: number;
    lon: number;
    label: string;
  }) => {
    const mapContainerRef = useRef<HTMLDivElement>(null);
    const mapInstanceRef = useRef<L.Map | null>(null);
    const markerRef = useRef<L.Marker | null>(null);

    useEffect(() => {
      if (!mapContainerRef.current) return;

      if (!mapInstanceRef.current) {
        const map = L.map(mapContainerRef.current, {
          center: [lat, lon],
          zoom: 20,
          preferCanvas: true,
          dragging: false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
          boxZoom: false,
          keyboard: false,
          zoomControl: false,
          touchZoom: false,
        });

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>',
        }).addTo(map);

        mapInstanceRef.current = map;
      }

      const map = mapInstanceRef.current!;

      if (!markerRef.current) {
        markerRef.current = L.marker([lat, lon], { draggable: false })
          .addTo(map)
          .bindPopup(label)
          .openPopup();
      } else {
        markerRef.current.setLatLng([lat, lon]).bindPopup(label).openPopup();
      }

      map.setView([lat, lon], 20);

      setTimeout(() => {
        map.invalidateSize();
      }, 100);

      return () => {
        if (markerRef.current) {
          markerRef.current.remove();
          markerRef.current = null;
        }
      };
    }, [lat, lon, label]);

    return (
      <div
        ref={mapContainerRef}
        className="h-48 w-full rounded-lg overflow-hidden"
        style={{ minHeight: "200px" }}
      />
    );
  };

  useEffect(() => {
    if (attendanceType === "SELFIE") {
      GetHistorySelfie();
    } else {
      GetHistory();
    }
  }, [attendanceType]);
  return (
    <>
      <SecondaryHeader title="Riwayat Kehadiran" pathname="home" />
      <div className="bg-main h-full">
        {/* <section id="main" className="relative px-5 -mt-28 z-50"> */}
        <div className="mt-4 z-100 z-30 mb-4 pb-24 px-5">
          {/* <div className=""> */}

          <p className="fixed z-[50] top-0 left-0 w-full bg-white py-4 text-center font-header font-bold">
            Riwayat Absen Minggu Ini
          </p>
          <div className="pt-14">
            {loading ? (
              <div className="flex justify-center items-center py-10">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
              </div>
            ) : historyData.length ? (
              historyData.map((prop: any, index: any) => {
                return (
                  <div className="relative rounded-2xl w-full bg-gray-50 p-3 shadow-md mb-4">
                    <p className="font-bold font-size ml-3">
                      {moment(prop?.createTime).format("dddd, DD MMMM YYYY")}
                    </p>
                    <p className="ml-3 font-normal text-xs text-slate-400">
                      {prop?.shift?.name}
                    </p>
                    <div className="flex flex-row">
                      <img src={signIn} alt="qr" className="h-10 p-2" />
                      <div className="rounded-full bg-white shadow-md h-fit my-auto w-36">
                        <p className="text-content p-1 pr-10 m-1 font-bold">
                          {prop?.checkInTime
                            ? moment(prop?.checkInTime).format("LT")
                            : "-"}{" "}
                          {prop?.checkInTime ? "WIB" : ""}
                        </p>
                      </div>
                      {prop?.status === "ON_TIME" ? (
                        <div
                          style={{ left: "10rem" }}
                          className="rounded-full bg-green-500 shadow-md h-fit absolute m-1"
                        >
                          <p className="text-content text-white p-1 m-1 font-bold">
                            Tepat Waktu
                          </p>
                        </div>
                      ) : prop?.status === "LATE" ? (
                        <div
                          style={{ left: "10rem" }}
                          className="rounded-full bg-red-500 shadow-md h-fit absolute m-1"
                        >
                          <p className="text-content text-white p-1 m-1 flex justify-center font-bold">
                            Terlambat
                          </p>
                        </div>
                      ) : (
                        <div
                          style={{ left: "10rem" }}
                          className="rounded-full bg-orange-500 shadow-md h-fit absolute m-1"
                        >
                          <p className="text-content text-white p-1 m-1 font-bold">
                            Toleransi
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-row">
                      <img src={signOut} alt="qr" className="h-10 p-2" />
                      <div className="rounded-full bg-white shadow-md h-fit my-auto">
                        <p className="text-content p-1 m-1 font-bold">
                          {prop?.checkOutTime
                            ? moment(prop?.checkOutTime).format("LT")
                            : "-"}{" "}
                          {prop?.checkOutTime ? "WIB" : ""}
                        </p>
                      </div>
                    </div>

                    <div
                      className="absolute top-1/2 right-3 transform -translate-y-1/2"
                      onClick={() => {
                        openPopup();
                        setDetailData(prop);
                      }}
                    >
                      <div className="bg-white shadow-md rounded-full p-2">
                        <FontAwesomeIcon
                          icon={"chevron-right"}
                          className="text-gray-500"
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : null}
            <Sheet
              isOpen={isVisible}
              onClose={() => {
                closePopup();
                setDetailData({});
              }}
            >
              <Sheet.Container style={{ height: "80%" }}>
                <Sheet.Header />
                <Sheet.Content>
                  <div
                    className="p-4 space-y-3 text-base"
                    style={{
                      maxHeight: "100%", // tinggi maksimal konten (misal 50% layar)
                      overflowY: "auto", // bikin konten bisa scroll
                    }}
                  >
                    <h2 className="text-xl font-bold mb-4">Detail Absensi</h2>
                    <p>
                      <b>Shift:</b> {detailData?.shift?.name}
                    </p>
                    <p>
                      <b>Check In:</b>{" "}
                      {detailData?.checkInTime
                        ? moment(detailData?.checkInTime).format("LT")
                        : "-"}{" "}
                      {detailData?.checkInTime ? "WIB" : ""}
                      {detailData?.checkInTime && (
                        <p>
                          {detailData?.location?.lat},{" "}
                          {detailData?.location?.lon}
                        </p>
                      )}
                      {detailData?.location?.lat &&
                        detailData?.location?.lon && (
                          <LeafletMap
                            lat={detailData.location.lat}
                            lon={detailData.location.lon}
                            label="📍 Lokasi Check In"
                          />
                        )}
                    </p>
                    <p>
                      <b>Check Out:</b>{" "}
                      {detailData?.checkOutTime
                        ? moment(detailData?.checkOutTime).format("LT")
                        : "-"}{" "}
                      {detailData?.checkOutTime ? "WIB" : ""}
                      {detailData?.checkOutTime && (
                        <p>
                          {detailData?.checkOutLocation?.lat},{" "}
                          {detailData?.checkOutLocation?.lon}
                        </p>
                      )}
                      {detailData?.checkOutLocation?.lat &&
                        detailData?.checkOutLocation?.lon && (
                          <LeafletMap
                            lat={detailData.checkOutLocation.lat}
                            lon={detailData.checkOutLocation.lon}
                            label="📍 Lokasi Check Out"
                          />
                        )}
                    </p>
                    <p>
                      <b>Status:</b>{" "}
                      {detailData?.status === "ON_TIME"
                        ? "Tepat Waktu"
                        : detailData?.status === "LATE"
                        ? "Terlambat"
                        : "Toleransi"}
                    </p>
                  </div>
                </Sheet.Content>
              </Sheet.Container>
              <Sheet.Backdrop
                onTap={() => {
                  closePopup();
                  setDetailData({});
                }}
              />
            </Sheet>
          </div>
        </div>
        {/* </section> */}
        <MenuBar label={"Riwayat"}></MenuBar>
      </div>
    </>
  );
};

export default History;
